// 404 — минималистичная страница в 7shifts-стилистике.
import { Link } from 'react-router-dom';

import { buttonVariants } from '@/components/ui/button';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-canvas-white p-8 text-center">
      <h1 className="text-display font-medium text-ink-black">404</h1>
      <p className="text-body text-muted-foreground">Страница не найдена.</p>
      <Link to="/dashboard" className={buttonVariants({ variant: 'default', size: 'lg' })}>
        На дашборд
      </Link>
    </div>
  );
}
